import OverviewVM from './overview-vm';

export default {
  init() {
    const args = {
      $el: $('#gradebook_grader'),
      course_id: $('#course_id').val(),
      coursework_id: $('#coursework_id').val(),
      student_id: $('#student_id').val(),
      filters: JSON.parse($('#filters').val() || '[]'),
      speed_grader: false,
      onReady() { }
    };

    ko.applyBindingsWithValidation(
      new OverviewVM(args),
      args.$el[0],
      { ...Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS, insertMessages: false }
    )
  }
};
